<template>
  <div>
    <!-- <h2>Ptown Property Search - {{ message }}</h2> -->
    <div>
      <!-- <img src="../assets/images/PeacefulHarbor_2.jpg" class="img-fluid" alt="Peaceful Harbor"> -->
      <!-- https://bootstrap-vue.js.org/docs/reference/images/ -->

      <!-- <div class="appTitleOverlay">
        <b-img :src="require('../assets/images/CapeTip_1.png')" fluid class="b-img"  alt="Peaceful Harbor"/>
        
        <p class="bottomRightTitle">Ptown.app</p>
        <p class="bottomRightSubTitle">Property Search</p>
      </div> -->
    </div>

    <!-- https://stackoverflow.com/questions/45565349/how-to-acces-external-json-file-objects-in-vue-js-app -->
    <div class="form-group">
      <input ref="searchField" onfocus="this.select();" onmouseup="return false;" type="text" v-model="search"
        placeholder="Owner Search" autofocus>
      <button class="btn btn-warning btn-sm" v-on:click="clearSearch">Clear Search</button>
      <button v-if="showSpeechIcon" class="btn btn-success btn-sm" v-on:click="_speech">Say Address</button>
    </div>

    <!-- https://stackoverflow.com/questions/45565349/how-to-acces-external-json-file-objects-in-vue-js-app -->
    <div v-for="prop in filteredProps" :key="prop.ID">
      <!-- <div v-for="prop in $options.properties"> -->
      <div class="card">
        <div class="card-header">
          <b>{{ prop.NAME1 }} </b>
        </div>
        <div class="card-body">
          <b-container>
            <b-row>
              <b-col>
                <p><b>Address</b> {{ prop.StreetNum }} {{ prop.StreetName }}<span v-if="prop.UnitNum">, {{ prop.UnitNum
                    }} </span></p>
              </b-col>
              <b-col>
                <p><b>Parcel ID</b> {{ prop.ParcelID }}</p>
              </b-col>
              <b-col>
                <p v-if="prop.NAME2"><b>Name 2</b> {{ prop.NAME2 }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p><b>Fiscal Year</b> {{ prop.FiscalYear }} </p>
              </b-col>
              <b-col>
                <p><b>Deed Date</b> {{ prop.Deed }}</p>
              </b-col>
              <b-col>
                <p><b>Acres</b> {{ prop.Acres }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p><b>Property Category</b> {{ prop.PropertyCategory }}</p>
              </b-col>
              <b-col>
                <p><b>Type</b> {{ prop.PropertyType }}</p>
              </b-col>
              <b-col>
                <p><b>Class</b> {{ prop.Class }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p><b>Buildings</b> {{ formatPrice(prop.Buildings) }}</p>
              </b-col>
              <b-col>
                <p><b>Land</b> {{ formatPrice(prop.Land) }}</p>
              </b-col>
              <b-col>
                <p><b>Total Value</b> {{ formatPrice(prop.TotalValue) }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p><b>Other</b> {{ formatPrice(prop.Other) }}</p>
              </b-col>
              <b-col>
                <p><b>Value Credit</b> {{ formatPrice(prop.ValueCredit) }}</p>
              </b-col>
              <b-col>
                <p><b>Taxable Credit</b> {{ formatPrice(prop.TaxableCredit) }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p v-if="prop.MailST"><b>Mailing Address</b> {{ prop.MailST }} {{ prop.MailCITY }} , {{ prop.MailSTAT
                  }} {{ prop.MailZIPC }}</p>
              </b-col>
            </b-row>

            <b-row>
              <div class="col-lg">
                <span class="UrlAnchor"><a :href="mapsOnlineUrl(prop.ParcelID)" class="btn btn-outline-info btn-sm"
                    target="_blank">Details</a></span>
                <!-- <span class="UrlAnchor"><a :href="mapsOnlineUrl(prop.ParcelID)" class="btn btn-outline-info btn-sm"
                      target="_blank">Details {{ mapsOnlineUrl(prop.ParcelID) }}</a></span> -->

                <span class="UrlAnchor"><a :href="googleMapsUrl(prop.StreetNum, prop.StreetName)"
                    class="btn btn-outline-success btn-sm" target="_blank">Map</a></span>
                <!-- <span class="UrlAnchor"><a :href = "prop.GoogleMapsUrl" class="btn btn-success" target="_blank">Show Google Map</a></span> -->

                <span class="UrlAnchor"><a :href="ptownAssessorUrl(prop.ParcelID)"
                    class="btn btn-outline-secondary btn-sm" target="_blank">Assessors Page</a></span>
                <!-- <span>Ptown Assessors Page {{ ptownAssessorUrl(prop.ParcelID) }}</span>           -->

                <span v-if="prop.Key != 0" class="UrlAnchor"><a :href="ptownAssessorCard(prop.Key)"
                    class="btn btn-outline-secondary btn-sm" target="_blank">Assessors Card</a></span>
                <!-- http://documents.provincetownma.s3.amazonaws.com/pk_cards_2021/1653.pdf -->

                <span v-if="prop.RegistryBook" class="UrlAnchor"><a
                    :href="registryOfDeedsLookup('BookPage', prop.RegistryBook, prop.RegistryPage)"
                    class="btn btn-outline-info btn-sm" target="_blank">Registry Book {{ prop.RegistryBook }} / Page
                    {{ prop.RegistryPage }}</a></span v-if="prop.RegistryBook">

                <span v-if="prop.RegistryCertificate" class="UrlAnchor"><a
                    :href="registryOfDeedsLookup('Certificate', prop.RegistryCertificate, '')"
                    class="btn btn-outline-info btn-sm" target="_blank">Registry Certificate
                    {{ prop.RegistryCertificate }}</a></span>

                <span v-if="prop.RegistryDocument" class="UrlAnchor"><a
                    :href="registryOfDeedsLookup('Document', prop.RegistryDocument, '')"
                    class="btn btn-outline-info btn-sm" target="_blank">Registry Document
                    {{ prop.RegistryDocument }}</a></span>

              </div>
            </b-row>
          </b-container>
          <div>
          </div>
        </div>
      </div>
    </div>
    <div class="resources">
      <div class="card">
        <div class="card-header">
          <h2>Resources</h2>
        </div>
        <div class="card-body">
          <p><a href="http://www.masslandrecords.com/Suffolk/" target="_blank">Suffolk County Land Records</a></p>
          <p><a
              href="https://www.mapsonline.net/provincetownma/web_assessor/search.php#offset=0&owner=&pid=&sid=663d43e2e2946c04a9cd2b400eed1ec0&streetName=&streetNum=&streetUnit="
              target="_blank">Ptown Assessor &mdash; Property Records Card Page</a></p>
          <p><a
              href="https://www.mass.gov/doc/property-type-classification-codes-non-arms-length-codes-and-sales-report-spreadsheet/download"
              target="_blank">Massachusetts Property Classification Code Book</a></p>
          <p><a href="https://www.mass.gov/service-details/property-coding-and-sales-reporting" target="_blank">MA
              <b>Division of Local Services</b> &mdash; <i>Property Coding and Sales Reporting</i></a></p>
          <p><a
              href="https://www.mass.gov/doc/igr-2019-8-certification-standards-guidelines-for-development-of-a-minimum-reassessment-program/download"
              target="_blank">Bureau of Local Assessment Informational Guideline Release 19-08</a>
          </p>
           <p>
            <a
              href="https://massgis.maps.arcgis.com/apps/OnePane/basicviewer/index.html?appid=47689963e7bb4007961676ad9fc56ae9"
              target="_blank"
              >Massachusetts Interactive Property Map</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PtownPropertyData from '../assets/PtownPropertyDataFY2022.json'

  export default {
    name: 'PropertySearch',
    // properties: PtownPropertyData2018,
    // props: {
    //   msg: String
    // },
    data: function () {
      return {
        message: "Welcome to Ptown.app!",
        seen: true,
        search: "260 Comm",
        properties: PtownPropertyData,
        showVoiceProgress: false,
        showSpeechIcon: false
      }
    },
    mounted() {
      this.$refs.searchField.focus();
      this._checkForSpeechRecognition();
    },
    created() {
      // SEE https://www.youtube.com/watch?v=G34_yNV8FMY
      // this.$http.get('../data/PtownPropertyData2018.json').then(function(data){
      //   this.properties = data.body.slice(0,10);
      // })
      // this.getPtownProperties();
    },
    computed: {
      // SEE: https://www.youtube.com/watch?v=G34_yNV8FMY
      filteredProps: function () {
        var searchTerm = this.search;
        if (searchTerm.length > 2) {
          searchTerm = searchTerm.toUpperCase();
          // console.log('searchTerm: ' + searchTerm);
          return this.properties.filter(property => {
            return property.SearchCriteria.match(searchTerm);
            // return property.NAME1.match(searchTerm);
          });
        }
      },
    },
    methods: {
      reverseMessage: function () {
        this.message = this.message
          .split("")
          .reverse()
          .join("");
      },

      ptownAssessorUrl: function (pid) {
        pid = pid.trim();
        pid = pid.replace("--", "-");
        var urlPart1 = 'https://www.mapsonline.net/provincetownma/web_assessor/search.php#offset=0&owner=&pid='
        var urlPart2 = '&sid=3c39b3b422ca2981565e402edb9439c1&streetName=&streetNum=&streetUnit=';

        return urlPart1 + pid + urlPart2;
      },

      ptownAssessorUrlOrig: function (pid) {
        pid = pid.trim();
        pid = pid.replace("--", "-");
        var urlPart1 = 'https://www.mapsonline.net/provincetownma/web_assessor/search.php#offset=0&owner=&pid=';
        var urlPart2 = '&sid=663d43e2e2946c04a9cd2b400eed1ec0&streetName=&streetNum=&streetUnit=';

        return urlPart1 + pid + urlPart2;
      },

      ptownAssessorCard: function (key) {
        key = key.trim();
        
        var urlPart1 = 'http://documents.provincetownma.s3.amazonaws.com/pk_cards_2021/';
        var urlPart2 = '.pdf';

        return urlPart1 + key + urlPart2;
      },

      mapsOnlineUrl: function (pid) {
        pid = pid.trim();
        pid = pid.replace("--", "-");
        // var pid = pid.replace("--", "-");
        var urlPart1 = 'https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=';
        var urlPart2 = '#';
        // console.log(urlPart1 + pid + urlPart2);
        return urlPart1 + pid + urlPart2;
      },

      registryOfDeedsLookup: function (action, item1, item2) {
        let url = ""

        switch (action) {
          case "BookPage":
            if (item1 == "" || item1 == "LAND") {
              url = "https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LR09D&WSKYCD=B"
            }
            else {
              url = "https://search.barnstabledeeds.org/ALIS/WW400R.HTM?W9BK=" + item1 + "&W9PG=" + item2 + "&WSHTNM=WW409R00&WSIQTP=LR09AP&WSKYCD=B&WSWVER=2#schTerms"
            }
            break;
          case "Certificate":
            if (item1 == "") {
              url = "https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC12D&WSKYCD=F"
            }
            else {
              url = "https://search.barnstabledeeds.org/ALIS/WW400R.HTM?W9CTFN=" + item1 + "&WSHTNM=WW412L00&WSIQTP=LC12LP&WSKYCD=F&WSWVER=2"
            }
            // console.log(action, item1, url);
            break;
          case "Document":
            if (item1 == "") {
              url = "https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC09D&WSKYCD=D"
            } else {
              url = "https://search.barnstabledeeds.org/ALIS/WW400R.HTM?W9DOCN=" + item1 + "&WSHTNM=WW409L00&WSIQTP=LC09AP&WSKYCD=D&WSWVER=2#schTerms"
            }
            // console.log(action, item1, url);
            break;
        }

        // https://search.barnstabledeeds.org/ALIS/WW400R.HTM?W9BK=13354&W9PG=280&WSHTNM=WW409R00&WSIQTP=LR09AP&WSKYCD=B&WSWVER=2#schTerms

        // Certificate: https://search.barnstabledeeds.org/ALIS/WW400R.HTM?W9CTFN=C208&WSHTNM=WW412L00&WSIQTP=LC12LP&WSKYCD=F&WSWVER=2

        // Document: https://search.barnstabledeeds.org/ALIS/WW400R.HTM?W9DOCN=400336&WSHTNM=WW409L00&WSIQTP=LC09AP&WSKYCD=D&WSWVER=2#schTerms

        return url;
      },

      googleMapsUrl: function (StreetNum, StreetName) {
        var urlPart1 = 'https://www.google.com/maps/place/';
        var urlPart2 = ', Provincetown,+MA+02657';
        return urlPart1 + StreetNum + ' ' + StreetName + urlPart2;
      },

      // https://stackoverflow.com/questions/43208012/how-do-i-format-currencies-in-a-vue-component
      formatPrice: function (value) {
        if (value == 'NA') {
          return "Not available"
        }
        else {
          let val = (value / 1).toFixed(0).replace(',', '.')
          return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
      },

      // https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=8-2-35--00B#

      clearSearch: function () {
        console.log('clearSearch')
        this.search = "";
        this.$refs.searchField.focus();

        // this.search = 'New Search';
        // this.$refs.searchField.focus();
        // this.clearSearch();
        // this.$refs.searchField.select();
      },

      showMap: function () {
        var mapUrl = "";
        // Template: https://www.google.com/maps/place/21+Ships+Way+Rd,+Provincetown,+MA+02657
      },

      _speech: function () {
        var vm = this;
        var youSaid = "";
        var street_name = "";
        var street_number = "";
        var address = "";
        var streetNameFirstChar = "";
        var streetNamePartOne = "";
        vm.showVoiceProgress = true;
        var recognition = new window.webkitSpeechRecognition();

        recognition.lang = "en-US";
        recognition.interimResults = false;
        recognition.maxAlternatives = 5;
        recognition.start();

        recognition.onresult = function (event) {
          youSaid = event.results[0][0].transcript;

          console.log("You said: ", youSaid);
          // Change the first character to upper case
          // youSaid = youSaid.charAt(0).toUpperCase() + youSaid.slice(1);
          // If no period at the end of the sentence, then add one
          //   if (youSaid.slice(-1) !== '.') {
          //     youSaid = youSaid + '.'
          //   }
          //      vm._clearSearch();

          vm.showVoiceProgress = false;

          address = youSaid.split(" ");
          street_number = address[0];
          streetNamePartOne = address[1];
          streetNameFirstChar = streetNamePartOne.substring(0, 1);
          // streetNameFirstChar.toUpperCase();
          console.log("address[1]: ", address[1]);
          vm.search = street_number + " " + streetNamePartOne;
          // vm.street_number = street_number;
          // vm.street_name = streetNamePartOne;
          console.log("streetNamePartOne: " + streetNamePartOne);
          vm.streetNamePartOne = streetNamePartOne;
          // vm.streetNameFirstChar = streetNameFirstChar;
          // vm.showStreets = true;
          // vm.showNumericKeypad = false;
          // vm.showUniqueAlphaFirstChars = true;

          // https://www.promptworks.com/blog/speech-recoginition-in-the-browser
          var voices = speechSynthesis.getVoices();
          var utterance = new SpeechSynthesisUtterance("You said, " + youSaid);
          utterance.voice = voices[0];
          speechSynthesis.speak(utterance);
        };
      },

      _checkForSpeechRecognition: function () {
        if (window.hasOwnProperty("webkitSpeechRecognition")) {
          // console.log('YOUR: working');
          this.showSpeechIcon = true;
        } else {
          // console.log('YOUR: not working on this browser');
          this.showSpeechIcon = false;
        }
      },

      getPtownProperties: function () {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "../assets/PtownPropertyData.json");

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 400) {
            var data = JSON.parse(xhr.responseText);
            app.properties = data;
            // renderHTML(data);
            // console.log(data);
          } else {
            console.log("We connected to the server, but it returned an error.");
          }
        };

        xhr.onerror = function () {
          console.log("Connection error");
        };

        xhr.send();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  button,
  input {
    margin-right: 0.5em;
    margin-bottom: 0.5em;
  }

  .UrlAnchor {
    margin-right: 0.5em;
    margin-bottom: 1em;
  }

  .b-img {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  /*********************************************************/
  /*********************************************************/
  /*              IMAGE TITLE OVERLAY CSS                  */
  /*********************************************************/
  /*********************************************************/
  .appTitleOverlay {
    position: relative;
    /*background: url(/images/css_textoverimage.jpg);*/
    /*width: 500px;
      height: 309px;*/
  }

  .bottomRightTitle {
    position: absolute;
    bottom: 0.5em;
    right: 0.5em;
    width: 400px;
    font-weight: bold;
    font-size: 3rem;
    text-align: right;
    color: #fff;
  }

  .bottomRightSubTitle {
    position: absolute;
    bottom: 0.05em;
    right: 1.2em;
    width: 200px;
    font-weight: bold;
    font-size: 150%;
    color: #fff;
  }

  .bottomLeft {
    position: absolute;
    bottom: 0;
    left: 0.5em;
    width: 400px;
    font-weight: bold;
  }

  .topLeftTitle {
    position: absolute;
    top: 1em;
    left: 0.5em;
    width: 400px;
    font-weight: bold;
    font-size: 200%;
  }

  .topLeftTitle2 {
    position: absolute;
    top: 1em;
    left: 1em;
    width: 400px;
    font-weight: bold;
    font-size: 200%;
  }

  .topRightTitle {
    position: absolute;
    top: 1em;
    right: 1em;
    width: 400px;
    font-weight: bold;
    font-size: 200%;
    text-align: right;
  }

  .bottomLeftTitle {
    position: absolute;
    bottom: 1em;
    left: 1em;
    width: 400px;
    font-weight: bold;
    font-size: 200%;
  }

  .topLeftSubTitle {
    position: absolute;
    top: 5em;
    left: 2em;
    width: 400px;
    font-weight: bold;
    font-size: 100%;
    color: #fff;
  }

  .resources {
    margin-bottom: 2em;
  }

  /* h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  } */
</style>